import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { Table } from 'primeng/table';
import { ApiService } from 'src/app/core/services/api.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { Investment, CURRENCY_SYMBOLS, CURRENCY_OPTIONS, InvestmentCurrency } from 'src/app/core/endpoints/models/investments';
import * as moment from "moment";
import { User } from 'src/app/core/endpoints/models/user.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-investments-user',
  templateUrl: './investments-user.component.html',
  styleUrls: ['./investments-user.component.scss']
})
export class InvestmentsUserComponent implements OnInit {
  @ViewChild('dt1') table: Table;
  @ViewChild('filter') filter: ElementRef;

  imageChangedEvent: Event | null = null;
  croppedActive: boolean = false;

  investments: Investment[] = [];
  usersOptions: any[] = [];
  loading: boolean = false;
  dialogInvestment: boolean = false;
  mode: 'edit' | 'register' = 'edit';
  stringPhoto: string = null;
  userId: any ;
  user: User;
  investmentSelected: Investment;

  currencyOptions = CURRENCY_OPTIONS;
  currencySymbols = CURRENCY_SYMBOLS;

  form: FormGroup = this.fb.group({
    user_id: ['', Validators.required],
    reference: ['', Validators.required],
    name: ['', Validators.required],
    interest: ['', [Validators.required]],
    amount: ['', [Validators.required]],
    currency: ['EUR', [Validators.required]],
    start_date: [null],
    end_date: [null],
    description: [''],
    image: ['']
  });

  constructor(
    private apiService: ApiService,
    private fb: FormBuilder,
    private toast: ToastService,
    private confirmationService: ConfirmationService,
    public router: Router
  ) {}

  ngOnInit(): void {
    let id = localStorage.getItem('userId');
    this.userId = id;
    this.dataUserId();
    this.loadInvestmentsUser();
    this.form.patchValue({
      user_id: this.userId
    });
  }

  dataUserId() {
    this.loading = true;
    this.apiService.getEntity('user',this.userId).subscribe({
      next: (result) => {
        this.user = result.user;
      },
      error: (err) => {
        this.loading = false;
        console.error(err);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  loadInvestmentsUser() {
    this.loading = true;
    this.apiService.getEntity('investments-user',this.userId).subscribe({
      next: (result) => {
        this.investments = result.investments.map(inv => ({
          ...inv,
          name_email: inv.user ? inv.user.name + ' - ' + inv.user.email : '',
          name_identification: inv.user ? inv.user.name + ' - ' + inv.user.identification : ''
        }));
      },
      error: (err) => {
        this.loading = false;
        console.error(err);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  clear(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  registerInvestment() {
    const formValue = this.form.value;
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return this.toast.show('Aviso', 'Revise los datos del formulario', 'warn');
    }
    this.loading = true;
    this.form.patchValue({ 
      image: this.stringPhoto
    });
	
    
      var startDate:any;
      if (typeof formValue.start_date === 'object') {
      startDate = moment(formValue.start_date).format('YYYY-MM-DD');
      } else {
      startDate = moment(formValue.start_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
      }
    
      var endDate:any;
      if (typeof formValue.end_date === 'object') {
      endDate = moment(formValue.end_date).format('YYYY-MM-DD');
      } else {
      endDate = moment(formValue.end_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
      }
      
      if (moment(endDate).isSameOrBefore(startDate)) {
        this.loading = false;
        return this.toast.show('Aviso', 'La fecha fin es menor o igual a la fecha de inicio.', 'warn');
      } 
  
      this.form.patchValue({ start_date: startDate });
      this.form.patchValue({ end_date: endDate });

    this.apiService.addEntity('registerInvestment', this.form.value).subscribe({
      next: (result) => {
        this.dialogInvestment = false;
        this.toast.show('Inversión creada correctamente');
        this.loadInvestmentsUser();
        this.croppedActive = false;
        this.resetForm();
      },
      error: (err) => {
        let message = 'Ocurrió un error al crear la inversión, inténtelo de nuevo';
        if (err && err.error && err.error.errors) {
          message = '';
          const errors = err.error.errors;
          for (const field in errors) {
            errors[field].forEach(errorMessage => {
              message += `${errorMessage}\n`;
            });
          }
        }
        this.loading = false;
        this.toast.show('Error', message, 'error');
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  updateInvestment() {
    const formValue = this.form.value;
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return this.toast.show('Aviso', 'Revise el formulario', 'warn');
    }
    this.loading = true;
    this.form.patchValue({ image: this.stringPhoto });
	
    
      var startDate:any;
      if (typeof formValue.start_date === 'object') {
      startDate = moment(formValue.start_date).format('YYYY-MM-DD');
      } else {
      startDate = moment(formValue.start_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
      }
    
      var endDate:any;
      if (typeof formValue.end_date === 'object') {
      endDate = moment(formValue.end_date).format('YYYY-MM-DD');
      } else {
      endDate = moment(formValue.end_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
      }
      
      if (moment(endDate).isSameOrBefore(startDate)) {
        this.loading = false;
        return this.toast.show('Aviso', 'La fecha fin es menor o igual a la fecha de inicio.', 'warn');
      } 
  
      this.form.patchValue({ start_date: startDate });
      this.form.patchValue({ end_date: endDate });

    this.apiService.updateEntity('updateInvestment', this.investmentSelected.id, this.form.value).subscribe({
      next: (result) => {
        this.toast.show('Inversión actualizada correctamente');
        this.dialogInvestment = false;
        this.loadInvestmentsUser();
        this.croppedActive = false;
        this.resetForm();
      },
      error: (err) => {
        let message = 'Ocurrió un error al editar la inversión, inténtelo de nuevo';
        if (err && err.error && err.error.errors) {
          message = '';
          const errors = err.error.errors;
          for (const field in errors) {
            errors[field].forEach(errorMessage => {
              message += `${errorMessage}\n`;
            });
          }
        }
        this.loading = false;
        this.toast.show('Error', message, 'error');
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  deleteInvestment(investment: Investment) {
    if (this.loading) return;
    this.confirmationService.confirm({
      message: '¿Está seguro que desea eliminar la inversión?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.loading = true;
        this.apiService.deleteEntity('deleteInvestment', investment.id).subscribe({
          next: () => {
            this.toast.show('Inversión eliminada correctamente');
            this.loadInvestmentsUser();
          },
          error: () => {
            this.toast.show('Error', 'Ocurrió un error eliminando la inversión, inténtelo de nuevo', 'error');
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  transactions(investment?: Investment) {
    localStorage.setItem('investment',investment.uuid);
    setTimeout(() => {
      if (investment) {
        this.router.navigate(['app/transactions']);
      }
    }, 250);
  }

  graphics(investment?: Investment) {
    localStorage.setItem('investment',investment.uuid);
    setTimeout(() => {
      if (investment) {
        this.router.navigate(['app/graphics']);
      }
    }, 250);
  }

  showDialog(investment?: Investment) {
    this.investmentSelected = undefined;
    this.stringPhoto = null;
    this.form.patchValue({
      user_id: this.userId
    });
    if (investment) {
      this.investmentSelected = investment;
      this.form.patchValue({
        reference: investment.reference,
        name: investment.name,
        interest: investment.interest,
        amount: investment.amount,
        currency: investment.currency || 'EUR',
        start_date: moment(investment.start_date+' 12:00:00').format('DD-MM-YYYY'),
        end_date: moment(investment.end_date+' 12:00:00').format('DD-MM-YYYY'),
        description: investment.description,
        image: investment.image
      });
      if (investment.image) {
        this.stringPhoto = investment.image;
      }
    }
    this.mode = investment ? 'edit' : 'register';
    this.dialogInvestment = true;
  }

  deleteImage() {
    this.stringPhoto = null;
    this.croppedActive = false;
  }

  resetForm() {
    this.form.reset();
    this.stringPhoto = null;
  }

  handleUpload(event: any) {
    this.imageChangedEvent = event;
    this.croppedActive = true;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.stringPhoto = event.base64;
  }
  imageLoaded(image: LoadedImage) {}
  cropperReady() {}
  loadImageFailed() {}

  formatNumber(num: number): string {
    const fixedNum = num.toFixed(2);
    const [integerPart, decimalPart] = fixedNum.split('.');
    const withThousands = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if(parseFloat(decimalPart) === 0){
      return withThousands;
    }
    return `${withThousands},${decimalPart}`;
  }

  getCurrencySymbol(currency?: InvestmentCurrency): string {
    return CURRENCY_SYMBOLS[currency] || CURRENCY_SYMBOLS['EUR'];
  }
}
